import React from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { useRootStore } from "../../../../store/contexts";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { FormSaveFooter } from "../../../../common/controls/forms/FormSaveFooter";

import FormExtras from "../../../../common/components/formExtras";
import { EmailVerificationCreateStore } from "../../store";
import { InputString } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type EmailVerificationCreateFormProps = {
  onSave?: () => void;
  onCancel?: () => void;
  /** Mientras se guarda, Guardar queda deshabilitado. */
  saving?: boolean;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
  emailSelectedValue?: { displayId: string; id: string } | null;
  onEmailChange?: (value: string) => void;
  email: string;
  emailError?: string;
  emailVerificationCreateStore: EmailVerificationCreateStore;
};

export const EmailVerificationCreateForm: React.FC<EmailVerificationCreateFormProps> =
  observer(
    ({
      onSave = () => {},
      onCancel = () => {},
      saving = false,
      showToolbox = true,
      showSaveFooter,
      email = "",
      emailError,
      onEmailChange = () => {},
      emailVerificationCreateStore,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              saveAndCloseLabel={langStore.saveEntity}
              closeLabel={langStore.cancelNewEntity}
              saveForm={() => onSave()}
              saveDisabled={saving}
              closeForm={() => onCancel()}
            />
          )}
          <Box>
            <FormExtras
              entity="EmailVerification"
              mode="create"
              values={{}}
              options={{}}
              onPatch={(campo: string, valor: any) => {
                switch (campo) {
                  case "email":
                    onEmailChange?.(valor);
                    break;
                }
              }}
            />
            <GroupContainer
              id="null"
              errorText={emailVerificationCreateStore.getCardErrors("null")}
              title={langStore.groupEmailVerificationLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <InputString
                  autoFocus
                  value={email}
                  error={Boolean(emailError)}
                  warning={
                    !emailError &&
                    Boolean(emailVerificationCreateStore.warnings["email"])
                  }
                  helperText={
                    emailError ||
                    emailVerificationCreateStore.warnings["email"]?.message
                  }
                  label={langStore.EmailVerificationEmailLabel}
                  onChange={(value: string) => onEmailChange(value)}
                  description={langStore.EmailVerificationEmailDescription}
                />
              </FormControl>
            </GroupContainer>
          </Box>
          {(showSaveFooter ?? !showToolbox) && (
            <FormSaveFooter
              onSave={() => onSave()}
              label={langStore.saveEntity}
              disabled={saving}
            />
          )}
        </Grid>
      );
    }
  );
